import React, { FC, ReactNode } from "react";
import cn from "classnames";
import { IFilteringItem } from "./types";

interface Props extends IFilteringItem {
  children: ReactNode;
  className?: string;
}

export const FilteringItem: FC<Props> = ({
  children,
  className,
  label,
  icon,
}) => {
  const combinedClassNames = cn(
    "flex flex-col gap-3 py-0 text-lg font-medium capitalize",
    className
  );

  return (
    <div className={combinedClassNames}>
      <span className="flex gap-2.5 justify-start text-purple-base">
        {icon && (
          <img className="w-6 aspect-square" src={icon.url} alt={icon.title} />
        )}
        <span>{label}</span>
      </span>
      {children}
    </div>
  );
};
